import { render, staticRenderFns } from "./MarketingFAQ.vue?vue&type=template&id=4097863a&"
import script from "./MarketingFAQ.vue?vue&type=script&lang=js&"
export * from "./MarketingFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports